import { render, staticRenderFns } from "./map_choice.vue?vue&type=template&id=a8c00b80"
import script from "./map_choice.vue?vue&type=script&lang=js"
export * from "./map_choice.vue?vue&type=script&lang=js"
import style0 from "./map_choice.vue?vue&type=style&index=0&id=a8c00b80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports